export default __webpack_public_path__ + "static/media/home_tender_loving_care.15dc3c13.mp3";